<div class="modal-header">
    <h4 class="modal-title">Orden de Entrega</h4>
    <label class="col-sm-4 pt-1">
      <ng-container *ngIf="orden.Estado.Id === 1">
      <h5><span class="badge badge-warning">{{orden.Estado.Nombre}}</span></h5>
      </ng-container>

      <ng-container *ngIf="orden.Estado.Id  === 2">
      <h5><span class="badge" style="background-color: #4caf50; color: white;">{{orden.Estado.Nombre}}</span></h5>
      </ng-container>

      <ng-container *ngIf="orden.Estado.Id  === 3">
      <h5><span class="badge badge-primary">{{orden.Estado.Nombre}}</span></h5>
      </ng-container>

      <ng-container *ngIf="orden.Estado.Id  === 4">
      <h5><span class="badge badge-danger" placement="top"
        [ngbPopover]="orden.Estado.ObservacionEstado"  triggers="mouseenter:mouseleave">{{orden.Estado.Nombre}}
      <i class="fa fa-info-circle"></i>
      </span></h5>
      </ng-container>

      <ng-container *ngIf="orden.Estado.Id  === 5">
      <h5><span class="badge badge-danger" placement="top"
        [ngbPopover]="orden.Estado.ObservacionEstado"  triggers="mouseenter:mouseleave">{{orden.Estado.Nombre}}
      <i class="fa fa-info-circle"></i>
      </span></h5>
      </ng-container>
  </label>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="formComprobante" class="theme-form" autocomplete="off">
      <div class="row p-2">
        <label class="col-sm-2">
           Nro. de Orden
        </label>
        <div class="col-sm-4">
            <input
            class="form-control"
            type="text"
            formControlName="nroOrden" readonly
            />
        </div>
        <label class="col-sm-2">
          Nro. de Grupo
        </label>
        <div class="col-sm-4">
            <input
            class="form-control"
            type="text"
            formControlName="nroGrupo" readonly
            />
        </div>
      </div>
      <div class="row p-2">
        <label class="col-sm-2">
           Fecha
        </label>
        <div class="col-sm-3">
            <input
            class="form-control"
            type="text"
            formControlName="fecha" readonly
            />
        </div>
        <label class="col-sm-1">
          Hora
        </label>
        <div class="col-sm-2">
            <input
            class="form-control"
            type="text"
            formControlName="hora" readonly
            />
        </div>
        <label class="col-sm-1">
          Sucursal
        </label>
        <div class="col-sm-3">
            <input
            class="form-control"
            type="text"
            formControlName="sucursal" readonly
            />
        </div>
      </div>
      <div class="row p-2">
          <label class="col-sm-2">
              Datos Entrega
          </label>
          <div class="col-sm-10">
              <input
              class="form-control"
              type="text"
              formControlName="datosEntrega" readonly
              />
          </div>
      </div>
    <div class="row p-2">
      <label class="col-sm-2">
          Observación
      </label>
      <div class="col-sm-10">
          <textarea class="form-control" rows="2" formControlName="Observacion" readonly></textarea>
      </div>
    </div>
      <div class="row pb-2">
          <div class="col-sm-12">
          </div>
      </div>
      <div class="row pb-2">
          <div class="col-sm-12">
            <div class="container order-history table-responsive wishlist">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th scope="col">Código</th>
                    <th scope="col">Nombre</th>
                    <th scope="col" class="text-right">Cant.Ped.</th>
                    <th scope="col" class="text-right">Cant.Env.</th>
                    <th scope="col">Obs.</th>
                    <th scope="col">Remitos</th>
                  </tr>
                </thead>
                <tbody>
                  <!--Recorre el modelo detalles-->
                  <tr *ngFor="let art of orden.Articulos">
                    <td scope="row">{{art.Codigo}}</td>
                    <td>{{art.Descripcion}}</td>
                    <td class="text-right">{{art.Cantidad | currency: "":"":".2-2":"es" }}</td>
                    <ng-container *ngIf="art.CantidadEnviada !== null"><td [ngStyle]="{'color':art.Cantidad !== art.CantidadEnviada? 'red' :'black'}" class="text-right">{{art.CantidadEnviada | currency: "":"":".2-2":"es" }}</td></ng-container>
                    <ng-container *ngIf="art.CantidadEnviada == null"><td [ngStyle]="{'color':'red'}" class="text-right">0.00</td></ng-container> 
                    <td><span *ngIf="art.Observacion !== null" placement="top" [ngbPopover]="art.Observacion"  triggers="mouseenter:mouseleave"><i class="fa fa-info-circle fa-1x"></i></span></td>
                    <td><a
                      href="javascript:void(0)"
                      (click)="getComprobante(art.Remito?.Id)">{{art.Remito?.Numero}}</a></td>
                  </tr>
                  <tr class="table-info font-weight-bold">
                    <td class="totales">Totales:</td> 
                    <td class="text-right totales">{{cantidadItems}}</td> 
                    <td class="text-right totales">{{cantidadTotal | currency: "":"":".2-2":"es" }}</td>
                    <td class="text-right totales">{{enviadosTotal | currency: "":"":".2-2":"es" }}</td>
                    <td class="text-right totales"></td>
                  </tr>
                </tbody>
              </table>
          </div>
        </div>
        <!-- <div class="col-md-12 text-right" style="font-weight: bold;">
          Total: {{total| currency: "":"":".2-2":"es"}}   
        </div> -->
      </div>
  </form>
  </div>
  <div class="modal-footer">
    <ng-container *ngIf= "orden.Estado.Nombre == 'En preparación'">
      <button type="button" class="btn btn-danger" (click)="anularOrden()">Anular Orden</button>
      </ng-container>
    <button type="button" class="btn btn-outline-dark" (click)="activeModal.close('Close click')">Cerrar</button>
  </div>